import { useQuery } from "@tanstack/react-query";
import type { StoreInviteView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useStoreInvitesQuery(storeSlug: string) {
  const query = useQuery({
    queryKey: queryKeys.seller.invites(storeSlug),
    queryFn: () => apiJsonClient<StoreInviteView[]>(endpoints.seller.invites),
    enabled: storeSlug.length > 0,
    // Acceptance happens in the invitee's session, so the inviter's cache can't
    // be invalidated cross-session. Refetch on mount/focus so a still-"pending"
    // invite clears as soon as the inviter revisits the team panel.
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
